const initialState = {
    modalopen:false,
    darkMode:localStorage.getItem("theme") === 'dark' ? 'dark' : localStorage.getItem("theme") === 'light' ? 'light' : 'dark',
    highcontrast:localStorage.getItem("theme") === 'high-contrast' ? 'high-contrast' : ''
}
const Mainreducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_OPEN': {
            return {
                ...state,
                modalopen: action.payload
            }
        }
        case 'DARK_MODE':{
            return{
                ...state,
                darkMode:action.payload
            }
        }
        case 'HIGH_CONTRAST':{
            return{
                ...state,
                highcontrast:action.payload
            }
        }
        default: {
            return state
        }
    }

}
export default Mainreducer;